function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.66952 94.2357C12.7757 99.6158 19.6551 101.459 25.0351 98.3529L56.1353 80.3973C59.6516 78.3671 60.8564 73.8708 58.8262 70.3545C56.7961 66.8382 52.2998 65.6334 48.7835 67.6635L7.94189 91.2434L9.66952 94.2357Z",
  fill: "#BAC1D1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.6088 128.869C56.2699 130.015 57.7341 130.407 58.8792 129.746C60.0243 129.085 60.4166 127.62 59.7555 126.475L37.2429 87.4824L33.0962 89.8765L55.6088 128.869Z",
  fill: "#DEE7EE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.3872 96.016C32.9455 96.983 34.182 97.3143 35.149 96.756L42.1734 92.7005C43.1404 92.1422 43.4717 90.9057 42.9134 89.9387C42.3551 88.9717 41.1186 88.6404 40.1517 89.1987L33.1272 93.2543C32.1602 93.8126 31.8289 95.049 32.3872 96.016Z",
  fill: "#D1D8E5"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-25.5028 33.3166C-27.4353 29.9695 -26.2885 25.6895 -22.9414 23.757C-19.5942 21.8246 -15.3142 22.9714 -13.3818 26.3185L20.6135 85.2001L8.49245 92.1982L-25.5028 33.3166Z",
  fill: "#DEE7EE"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.7358 127.724C44.1268 126.669 44.4882 125.32 45.5431 124.711L61.1805 115.683C62.2354 115.074 63.5843 115.435 64.1934 116.49L44.7358 127.724Z",
  fill: "#DEE7EE"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.8688 124.525L51.4733 134.233C51.8293 134.849 51.618 135.638 51.0014 135.994C50.3848 136.35 49.5964 136.138 49.2404 135.522L44.9251 128.047C44.2131 126.814 44.6356 125.237 45.8688 124.525Z",
  fill: "#DEE7EE"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.8575 115.87L66.462 125.577C66.818 126.194 67.6064 126.405 68.223 126.049C68.8396 125.693 69.0509 124.905 68.6949 124.288L64.3795 116.814C63.6675 115.581 62.0907 115.158 60.8575 115.87Z",
  fill: "#DEE7EE"
});

var _ref9 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 67.8363,
  cy: 125.002,
  rx: 2.57825,
  ry: 2.57314,
  transform: "rotate(-30 67.8363 125.002)",
  fill: "#DEE7EE"
});

var _ref10 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 50.6119,
  cy: 134.945,
  rx: 2.57825,
  ry: 2.57314,
  transform: "rotate(-30 50.6119 134.945)",
  fill: "#DEE7EE"
});

var SvgMchair = function SvgMchair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 87,
    height: 145,
    viewBox: "0 0 87 145",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMchair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mchair.d19f61b7.svg";
export { ForwardRef as ReactComponent };